import React from 'react';
import { Text, Box, Icons, variables, breakpoints, space } from '@generationtux/component-library';
import { deselectItem, scrollTop } from '../../../utils/utils';
import PreviewLayerThumbnails from '../preview/PreviewLayerThumbnails';
import CategoryIcon from '../../shared/CategoryIcon';
import styled from 'styled-components';

const ButtonIcon = styled(Box)`
  width: ${space[4]}px;
  display: grid;
  place-items: center;
  cursor: pointer;
  @media (hover: hover) {
    &.trashcan:hover {
      line,
      rect {
        stroke: ${props => variables(props).danger};
      }
    }
  }
  @media (min-width: ${props => breakpoints.md}) {
    width: ${space[4]}px;
  }
`;
const PreviewLayerThumbnailsWrap = styled(Box)`
  position: relative;
  width: ${space[4]}px;
  min-height: 40px;
  img {
    max-width: 40px;
  }
  @media (min-width: ${props => breakpoints.xs}) {
    width: ${space[5]}px;
    min-height: 48px;
  }
`;

const ListItemStyled = styled(Box)`
  position: relative;
  transition: all 0.15s ease;
  .line-clip {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  @media (min-width: ${props => breakpoints.sm}) {
    .line-clip {
      white-space: normal;
    }
  }
  .edit-add {
    flex-grow: 1;
    width: 80%;

    cursor: pointer;
    transition: all 0.15s ease;
    :active {
      transform: scale(0.95);
    }
    @media (hover: hover) {
      &:hover {
        background-color: ${props => variables(props).white};
        box-shadow: ${props => variables(props).shadows[1]};
      }
    }
  }
`;

const ListItem = ({ category, product, selectedCatalogNumbers, setActiveCollection, docBrownsTimeMachine }) => {
  const name = product && product.catalogName;
  const price = product && product.costToCustomer;

  return (
    <ListItemStyled display="flex" alignItems="center" onTouchStart={() => {}}>
      <Box
        className="edit-add"
        display="grid"
        style={{ gridTemplateColumns: 'auto 1fr auto' }}
        alignItems="center"
        onClick={() => {
          scrollTop();
          setActiveCollection(category.name);
        }}
      >
        <PreviewLayerThumbnailsWrap py={1} display="flex" justifyContent="center" alignItems="center">
          {!name ? (
            <CategoryIcon category={category.category} color="textPrimary" />
          ) : (
            <PreviewLayerThumbnails product={product} />
          )}
        </PreviewLayerThumbnailsWrap>

        {name ? (
          <>
            <Text pl={2} size="sm" textColor="grayDarker" className="line-clip">
              <Box display="inline" as="span" mr={1}>
                {name}
              </Box>
              <Box as="span" display="none" displaySm="inline">
                <Text size="sm" as="span" textColor="textPrimary">
                  Edit
                </Text>
              </Box>
            </Text>
            <Box display="flex" justifyContent="flex-end" ml={1} mr={3} style={{ flexGrow: 1 }}>
              <Text size="sm" textColor="grayDarker">
                ${price}
              </Text>
            </Box>
          </>
        ) : (
          <>
            <Text pl={2} size="sm" textColor="textPrimary">
              {category.name}
            </Text>
            <Box display="flex" justifyContent="flex-end" mr={3} style={{ flexGrow: 1 }}>
              <Icons.Plus color="textPrimary" />
            </Box>
          </>
        )}
      </Box>
      <Box display="flex" alignItems="stretch">
        {price !== null ? (
          <ButtonIcon
            buttonType="link"
            px={0}
            title={`Remove ${category.name}`}
            className="trashcan"
            onClick={() => {
              docBrownsTimeMachine(deselectItem(selectedCatalogNumbers, category.name), true, null);
            }}
          >
            <Icons.Trashcan />
          </ButtonIcon>
        ) : (
          <ButtonIcon />
        )}
      </Box>
    </ListItemStyled>
  );
};

export default ListItem;
